import { deepCopy } from '@/util/deep-copy'
const GroupPriority = {
    level0: 0,
    level1: 1,
    level2: 2,
    level3: 3,
    level4: 4,
}
const RoutingPolicy = {
    Stop: 'stop',                       // 해당 라우트 핸들러 이후에는 모두 스탑
    Go: 'go',                           // 해당 라우트 핸들러 이후에 조건없이 모든 핸들러 호출
}


class EventController {
    constructor(keys) {
        if (keys == undefined) { keys = [] }
        this.keys = keys
        window.eventRouters = []
        for (let i=0 ; i<keys.length ; i++) {
            let key = keys[i]
            window.addEventListener(key, this._handleEvent)
        }
        this.routers = []
        this.Enum = {
            GroupPriority: GroupPriority,
            RoutingPolicy: RoutingPolicy
        }
    }

    // MARK: - Private
    _handleEvent(e) {
        let eventKey = e.type
        if (window.eventRouters == undefined) { return }
        let routers = window.eventRouters[eventKey]?.filter(r => r.eventKey == eventKey) ?? []
        routers.sort( (l, r) => { return r.priority - l.priority } )
        if (routers == undefined) { return }
        let router = routers[0]
        if (router == undefined) { return }
        router.handler(e)
        if (router.policy == RoutingPolicy.Stop) { 
            e.preventDefault()
        }
        return
    }

    // MARK: - Public
    getNextRouteObject(eventKey, groupKey) {
        let routers = this.routers.filter(r => r.eventKey == eventKey) ?? []
        routers.sort( (l, r) => { return r.priority - l.priority } )
        if (routers.length == 0) {
            routers = [{
                target: undefined,
                eventKey: eventKey,
                groupKey: groupKey,
                priority: 0,
                policy: RoutingPolicy.Go,
                handler: undefined
            }]
        }
        let firstObj = routers[0]
        firstObj = deepCopy(firstObj)
        firstObj.priority += 1
        delete firstObj.target
        delete firstObj.handler
        return firstObj
    }

    registRouter(obj) {
        this.routers.push(obj)
        if (window.eventRouters == undefined) { window.eventRouters = {} }
        if (window.eventRouters[obj.eventKey] == undefined) { window.eventRouters[obj.eventKey] = [] } 
        window.eventRouters[obj.eventKey].push(obj)
    }

    unregistRouter(target) {
        let routers = this.routers.filter(r => r.target == target)
        for (let i=0 ; i<routers.length ; i++) {
            let router = routers[i]
            this.removeRouteObject(router)
        }
    }

    destroyObject() {
        for (let i=0 ; i<this.keys.length ; i++) {
            let key = this.keys[i]
            window.removeEventListener(key, this._handleEvent)
        }
        for (let i=0 ; i<this.routers.length ; i++) {
            let router = this.routers[i]
            this.removeRouteObject(router)
        }
    }

    removeRouteObject(router) {
        let index = this.routers.indexOf(router)
        this.routers.splice(index, 1)
        let eventKey = router.eventKey
        
        index = window.eventRouters[eventKey].indexOf(router)
        window.eventRouters[eventKey].splice(index, 1)
    }
}


export default EventController